import { Component, OnInit, Input } from '@angular/core';
import { Colegio } from 'src/app/interfaces/colegio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColegiosService } from 'src/app/services/colegios.service';
import { UserService } from 'src/app/services/user.service';

import * as moment from 'moment-timezone';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  @Input() nombres: string;
  @Input() apellidos: string;
  @Input() colegio: Colegio;
  @Input() genero: string;
  @Input() id: string;
  @Input() rol: string;
  @Input() nombreCurso: string;

  background = '#23273B';
  avatar: any = 'assets/img/logoColegia.png';

  loading = false;

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private colegioService: ColegiosService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    console.log('id header', this.id);
    if (this.colegio.background) {
      this.background = this.colegio.background;
    }
    if (this.colegio.avatar) {
      this.avatar = this.colegio.avatar;
    }
  }

  irMagisterio() {
    this.loading = true;
    const tiempoMagisterio = moment().tz('Europe/Madrid').toDate();
    // Convertir a Timestamp si usas Firestore
    // @ts-ignore
    console.log('tiempoMagisterio', tiempoMagisterio);

    console.log('id', this.id);

    if (!this.id) {
      this.loading = false;
      alert(
        'Error al intentar ingresar en la pÃ¡gina. Por favor, intÃ©ntalo de nuevo mÃ¡s tarde.'
      );
      return;
    }

    const codigoMagisterio = Array.from({ length: 16 }, () =>
      Math.random().toString(36).charAt(2)
    )
      .join('')
      .toUpperCase();
    console.log('codigoMagisterio', codigoMagisterio);

    // const magisterioInfo = {
    //   tiempoMagisterio: tiempoMagisterio,
    //   codigoMagisterio: codigoMagisterio,
    // };

    this.userService
      .editUser({ tiempoMagisterio, codigoMagisterio }, this.id)
      .then(() => {
        const params = new HttpParams()
          .set('codigo', codigoMagisterio)
          .set('colegio', this.nombreCurso ?? '');

        this.http
          .get<any>(
            'https://us-central1-the-campus-56b06.cloudfunctions.net/app/tokenMagisnet',
            { params }
          )
          .subscribe((data) => {
            this.loading = false;
            if (data == 'error') {
              alert(
                'Error al intentar ingresar en la pÃ¡gina. Por favor, intÃ©ntalo de nuevo mÃ¡s tarde.'
              );
              return;
            }
            console.log('token', data);
            const token = data;
            window.open(
              `https://www.magisnet.com/wp-json/magisnet-sso-for-the-campus/v1/login?token=${token}`
            );
          });
      });
  }
}
